import { Handle, Position, type NodeProps } from "@xyflow/react";
import { Box, Chip, Typography } from "@mui/material";
import OutboxOutlinedIcon from "@mui/icons-material/OutboxOutlined";
import type { PrepFlowNodeData } from "../../utils/graphAdapter";
import { useAppCustomStyles } from "../../../../assets/theme/custom/hooks";

export default function PrepOutputNode({ data }: NodeProps) {
  const flowData = data as PrepFlowNodeData;
  const custom = useAppCustomStyles();
  const node = flowData.graphNode;
  const status = node.indexApprovalStatus ?? "PENDING";
  return (
    <Box
      sx={custom.components.dataPrep.outputNode}
    >
      <Handle type="target" position={Position.Left} />
      <Box sx={custom.components.dataPrep.flowNodeTitleRow}>
        <OutboxOutlinedIcon fontSize="small" color="secondary" />
        <Typography variant="subtitle2" fontWeight={600}>
          Output
        </Typography>
      </Box>
      <Typography variant="caption" color="text.secondary" sx={custom.components.dataPrep.flowNodeCaption}>
        {node.targetIndex || "— target index —"}
      </Typography>
      <Chip size="small" label={status} sx={custom.components.dataPrep.outputNodeChip} color={status === "APPROVED" ? "success" : "default"} />
    </Box>
  );
}
